<template>
  <vue-final-modal :model-value="true" :hide-overlay="true" :focus-trap="true" :click-to-close="false"
    :esc-to-close="!isSubmitting" @update:model-value="onClose" @opened="onOpened">
  <div class="loginmodal mega-signup-overlay">
    <section class="joinwrap">
      <header class="mega-signup-heading">
        <img class="mega-signup-logo" src="@/assets/img/mega-login-logo.png" alt="메가 CASINO" />
        <h1 id="mega-signup-title">Member's Join</h1>
        <p>{{ $t('front.common.signup') }}</p>
      </header>
      <form @submit.prevent="onSubmit" :aria-busy="isSubmitting">
        <div class="joininwrap">
          <div class="mega-signup-column">
            <label for="join-id">{{ $t('front.common.memId') }}</label>
            <input id="join-id" name="signupMemId" v-model="model.memId" :placeholder="$t('front.signup.memIdPlaceholder')" autocomplete="username" autocapitalize="none" :spellcheck="false" />
            <label for="join-nick">{{ $t('front.common.nickName') }}</label>
            <input id="join-nick" v-model="model.memNick" :placeholder="$t('front.signup.nickNamePlaceholder')" />
            <label for="join-pass">{{ $t('front.common.password') }}</label>
            <input id="join-pass" type="password" v-model="model.memPass" :placeholder="$t('front.signup.passwordPlaceholder')" autocomplete="new-password" />
            <label for="join-pass-check">{{ $t('front.common.passwordCheck') }}</label>
            <input id="join-pass-check" type="password" v-model="model.memPassCheck" :placeholder="$t('front.signup.passwordPlaceholder')" autocomplete="new-password" />
            <label for="join-recommender">{{ $t('front.common.recommandId') }}</label>
            <input id="join-recommender" v-if="!joinRecommenderId" v-model="model.recommenderId" :placeholder="$t('front.signup.recommandIdPlaceholder')" />
            <input id="join-recommender" v-else :value="joinRecommenderId" readonly />
            <label for="join-phone">{{ $t('front.common.phone') }}</label>
            <input id="join-phone" type="tel" v-model="model.memPhone" :placeholder="$t('front.signup.phonePlaceholder')" autocomplete="tel" />
            <small>휴대폰 번호는 정확하게 입력해 주세요.</small>
          </div>
          <div class="mega-signup-column">
            <label for="join-bank">{{ $t('front.common.bankSelect') }}</label>
            <select id="join-bank" v-model="model.bank">
              <option :value="''" disabled>{{ $t('front.common.bankSelect') }}</option>
              <option v-for="item in bankList" :key="item.bankCode" :value="item.bankCode">{{ item.bankNameKr }}</option>
            </select>
            <small>은행 정보는 충전과 환전에 필요한 정보이니 정확히 입력해 주세요.</small>
            <label for="join-account-name">{{ $t('front.common.bankName') }}</label>
            <input id="join-account-name" v-model="model.memName" :placeholder="$t('front.common.bankName')" autocomplete="name" />
            <label for="join-account">{{ $t('front.common.bankAcc') }}</label>
            <input id="join-account" v-model="model.bankacc" :placeholder="$t('front.common.bankAccOnlyNumber')" inputmode="numeric" />
            <label for="cashOutPass">{{ $t('front.common.cashOutPass') }}</label>
            <input id="cashOutPass" type="password" maxlength="4" v-model="model.cashOutPass" :placeholder="$t('front.signup.cashOutPassPlaceholder')" inputmode="numeric" autocomplete="new-password" />
            <label for="join-cash-pass-check">{{ $t('front.common.cashOutPass') }} 확인</label>
            <input id="join-cash-pass-check" type="password" maxlength="4" v-model="cashOutPassCheck" placeholder="출금 비밀번호를 다시 입력해 주세요." inputmode="numeric" autocomplete="new-password" />
          </div>
        </div>
        <div class="mega-signup-actions">
          <button type="button" class="mega-signup-cancel" :disabled="isSubmitting" @click="onClose">{{ $t('front.button.cancel') }}</button>
          <button type="submit" class="loginnbtn on" :disabled="isSubmitting">{{ isSubmitting ? '가입 신청 중…' : $t('front.common.signup') }}</button>
        </div>
      </form>
      <button type="button" class="loginclose" aria-label="회원가입 닫기" :disabled="isSubmitting" @click="onClose"><img src="@/assets/img/icon_x.svg" alt="" /></button>
    </section>
  </div>
  </vue-final-modal>
</template>

<script>

import { getBankList, signUp } from '@/api/member'
import { isValidOnlyNumber, isValidOnlyPhoneNumber, isValidPassword, isValidUserId } from '@/libs/utils'
import { mapState } from 'vuex'

export default {
  name: 'Join',
  computed: {
    ...mapState([
      'siteOption',
      'joinRecommenderId'
    ])
  },
  watch: {

  },
  created () {
    this.loadBankList()
  },
  methods: {
    onOpened ({ ref }) {
      ref.vfmContainer.value.setAttribute('aria-labelledby', 'mega-signup-title')
    },
    onAlert (level, message) {
      this.onNotice(message, '회원가입 실패')
    },
    loadBankList () {
      getBankList({}).then(response => {
        const result = response.data
        if (result.resultCode === '0') {
          const data = result.data
          this.bankList = data.list
        }
      })
    },
    isValidate () {
      const data = this.model
      for (const key of Object.keys(data)) {
        const value = data[key]
        if (key === 'memId') {
          if (value === '') {
            this.onAlert('warningart', 'front.member.emptyMemId')
            return false
          }

          if (!isValidUserId(value)) {
            this.onAlert('warningart', 'api.U101')
            return false
          }
        }

        if (key === 'memPassCheck') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.compareMemPass')
            return false
          }
        }

        if (key === 'memPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemPass')
            return false
          }

          if (!isValidPassword(value) || value.length > 20) {
            this.onAlert('warningart', 'api.U102')
            return false
          }
        }

        if (key === 'cashOutPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyCashOutPass')
            return false
          }

          if (!isValidOnlyNumber(value) || value.length !== 4) {
            this.onAlert('warningart', 'api.U103')
            return false
          }
        }

        if (key === 'memNick') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemName')
            return false
          }

          if (value.length > 20 || value.length < 2) {
            this.onAlert('warningart', 'api.U105')
            return false
          }
        }

        if (key === 'memPhone') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemTel')
            return false
          }

          if (!isValidOnlyPhoneNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidMemTel')
            return false
          }
        }

        if (key === 'recommenderId') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyRecommenderId')
            return false
          }
        }

        if (key === 'bank') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankName')
            return false
          }
        }

        if (key === 'memName') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankAccountName')
            return false
          }
        }

        if (key === 'bankacc') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankNumber')
            return false
          }

          if (!isValidOnlyNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidBankNumber')
            return false
          }
        }

        if (data.memPass !== data.memPassCheck) {
          this.onAlert('warningart', 'front.member.compareMemPass')
          return false
        }
      }

      if (data.cashOutPass !== this.cashOutPassCheck) {
        this.onAlert('warningart', '출금 비밀번호 확인이 일치하지 않습니다.')
        return false
      }
      return true
    },
    onClose () {
      this.onNotice(null)
      this.$emit('close', false)
    },
    onSubmit (nextPageName) {
      if (this.isSubmitting) return
      if (this.isValidate()) {
        this.isSubmitting = true
        this.model.memPhone = this.model.memPhone.toString()
        return signUp(this.model).then(async response => {
          const result = response.data
          if (result.resultCode === '0') {
            this.onNotice(null)
            await this.onCheck('front.member.completeSignup')
            if (nextPageName && typeof nextPageName === 'string') {
              this.goPageByName(nextPageName)
            } else {
              this.$emit('close', true)
            }
          } else {
            this.onAlert('warningart', 'api.' + result.resultCode)
          }
        }).catch(err => {
          console.error('singup err : ', err)
          this.onAlert('warningart', '서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.')
        }).finally(() => {
          this.isSubmitting = false
        })
      }
    }
  },
  data () {
    return {
      bankList: [],
      cashOutPassCheck: '',
      isSubmitting: false,
      model: {
        siteName: '',
        siteType: '',
        ip: '',
        apiKey: '',
        memId: '',
        memPass: '',
        memPassCheck: '',
        memPhone: '',
        memPhoneVendor: '',
        memLevel: '1',
        bank: '',
        memName: '',
        memNick: '',
        bankacc: '',
        cashOutPass: '',
        nationCode: '',
        partSendYn: 'N',
        maxCredit: '',
        creditStatus: '',
        firstBetConfYn: 'N',
        commissionGroup: '',
        recommenderId: '',
        partnerType: '',
        memStatus: 0,
        membetType: ''
      }
    }
  }
}
</script>

<style scoped>
.mega-signup-overlay { position: fixed; inset: 0; z-index: 999; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 16px; background: #b9daf2 url('../../assets/img/mega-login-curtains.png') center / cover no-repeat; color: #e5e7eb; font-family: 'Mega SUIT', Arial, sans-serif; }
.joinwrap { position: relative; box-sizing: border-box; width: 578px; max-width: 100%; max-height: calc(100dvh - 32px); overflow-y: auto; padding: 0 26px 30px; border: 2px solid #92e4d1; border-right-color: #b28af0; border-bottom-color: #b28af0; border-radius: 8px; background: rgba(35, 43, 54, .72); backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px); }
.mega-signup-heading { text-align: center; padding-bottom: 16px; margin-bottom: 12px; border-bottom: 1px solid #d9e5f033; }
.mega-signup-logo { display: block; width: 280px; max-width: 80%; height: 160px; object-fit: contain; margin: -8px auto 0; }
.mega-signup-heading h1 { margin: 4px 0 2px; color: #baffeb; font-size: 21px; line-height: 1.2; text-shadow: 0 0 8px #6cdecc; }
.mega-signup-heading p { margin: 0; font-size: 12px; }
.joininwrap { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 26px; }
.mega-signup-column { min-width: 0; }
.mega-signup-column label { display: block; margin: 6px 0 3px; font-size: 11px; line-height: 1.3; font-weight: 700; }
.mega-signup-column input, .mega-signup-column select { box-sizing: border-box; display: block; width: 100%; min-width: 0; height: 32px; padding: 0 8px; border: 1px solid #979797; border-radius: 4px; background: #333; color: #f5f5f5; font: inherit; font-size: 12px; }
.mega-signup-column input::placeholder { color: #c2c2c2; opacity: 1; }
.mega-signup-column small { display: block; margin-top: 4px; color: #d1d7df; font-size: 10px; line-height: 1.2; word-break: keep-all; }
.mega-signup-actions { display: flex; justify-content: center; gap: 6px; margin-top: 22px; }
.mega-signup-actions button { width: 104px; min-height: 36px; border: 0; border-radius: 5px; font: inherit; font-size: 13px; font-weight: 700; cursor: pointer; }
.mega-signup-actions .loginnbtn { color: #202039; background: linear-gradient(135deg, #94e0ee, #ac7def); }
.mega-signup-cancel { color: #fff; background: linear-gradient(#63696b, #303437); }
button:disabled { opacity: .6; cursor: wait; }
.loginclose { position: absolute; display: grid; place-items: center; top: 4px; right: 4px; width: 36px; height: 36px; padding: 10px; border: 0; border-radius: 8px; background: transparent; cursor: pointer; }
.loginclose img { width: 16px; height: 16px; filter: brightness(1.8); }
input:focus-visible, select:focus-visible, button:focus-visible { outline: 2px solid #baffeb; outline-offset: 2px; }
@media (max-width: 520px) {
  .joinwrap { padding: 0 20px 24px; }
  .joininwrap { grid-template-columns: minmax(0, 1fr); gap: 0; }
  .mega-signup-logo { height: 130px; }
  .mega-signup-column input, .mega-signup-column select { height: 42px; font-size: 14px; }
  .mega-signup-column label { font-size: 13px; }
  .mega-signup-actions button { min-height: 44px; }
}
</style>
